import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicOrderRedirectResponse {
  @jsonMember(String)
  public readonly number!: string;

  @jsonMember(String)
  public readonly redirectUrl!: string;
}
